import { useContext } from "react";

import styles from "./booking.module.scss";
import { bookingNavBarLogo, zenvolyaNewLogo } from "../../../constant";
import { StateContext } from "../../../context/globalContext/context";
import { iGlobalContext } from "../../../context/globalContext/interface";
import { isPartnerBranding } from "../../../utils/partnerBranding";

function BookingNavBar({ onLogoClick }: { onLogoClick: () => void }): JSX.Element {
  const { branding }: iGlobalContext = useContext(StateContext);

  const partnerBranding = isPartnerBranding(branding);
  // Theme Studio "Top bar = Light" paints this bar white, so it takes the normal
  // (dark-on-light) logo like the main navbar; every other style keeps the
  // dark-background logo this bar ships with.
  const lightBar = branding?.theme?.components?.header?.style === "light";
  const logoSrc = lightBar
    ? (partnerBranding && branding?.logoUrl) || zenvolyaNewLogo
    : (partnerBranding && (branding?.logoDarkUrl || branding?.logoUrl)) || bookingNavBarLogo;

  return (
    <div className={styles.header}>
      <img
        src={logoSrc}
        alt={partnerBranding && branding?.name ? `${branding.name} logo` : "logo"}
        className={styles.logo}
        onClick={onLogoClick}
      />
    </div>
  );
}

export default BookingNavBar;
